<div class="card card-custom" style="min-height: 100%" [ngClass]="class" #portlet>
  <ng-content></ng-content>
</div>
